/**
 * SendBot Application Configuration
 */

export const appConfig = {
  name: import.meta.env['VITE_APP_NAME'] || 'SendBot',
  id: import.meta.env['VITE_APP_ID'] || 'sendbot',
  tokenPrefix: import.meta.env['VITE_TOKEN_PREFIX'] || 'sb_',
  githubUrl: import.meta.env['VITE_GITHUB_URL'] || '',
  footerText: import.meta.env['VITE_FOOTER_TEXT'] || '© 2026 SendBot',
} as const

export function getThemeStorageKey(): string {
  return `${appConfig.id}-theme`
}

export function getSentryRelease(version: string): string {
  return `${appConfig.id}@${version}`
}

export type AppConfig = typeof appConfig
